import {
  HomeIcon,
  MapIcon,
  CalendarDaysIcon,
  ChatBubbleLeftRightIcon,
  Bars3Icon,
} from '@heroicons/react/24/outline';

export interface MobileTab {
  id: string;
  label: string;
  icon: React.ComponentType<{ className?: string }>;
  route: string | null; // null = "More" action (opens sidebar)
}

export const MOBILE_TABS: MobileTab[] = [
  { id: 'home', label: 'Home', icon: HomeIcon, route: '/dashboard' },
  { id: 'destinations', label: 'Explore', icon: MapIcon, route: '/destinations' },
  { id: 'itinerary', label: 'Itinerary', icon: CalendarDaysIcon, route: '/itinerary' },
  { id: 'ask', label: 'Ask AI', icon: ChatBubbleLeftRightIcon, route: '/ask-questions' },
  { id: 'more', label: 'More', icon: Bars3Icon, route: null },
];
